import { UUID } from '../core/context/uuid/entity';
import { AssetRelationType } from './context/asset-relation-type/entity';

export const assetRelationTypes: AssetRelationType[] = [
    new AssetRelationType({ id: new UUID().toString(), name: 'Network' }),
    new AssetRelationType({ id: new UUID().toString(), name: 'Electrical' }),
    new AssetRelationType({ id: new UUID().toString(), name: 'Logical' }),
];
